import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectEntitlementProductSubscriptionResponseMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_PFIX_PRODUCT_SUBSCRIPTION_MANAGEMENT_RESP);
        this.Id = -1;
        this.ReqType = null;
        this.ReqStatus = null;
        this.ReqTime = null;
        this.ResponseEnd = null;
        this.ErrorCode = null;
        this.Comment = null;
    }
}
